import { render, staticRenderFns } from "./ListCheckRed.vue?vue&type=template&id=11724733&"
import script from "./ListCheckRed.vue?vue&type=script&lang=js&"
export * from "./ListCheckRed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports